import { Injectable } from '@angular/core';
import { AngularDataContext } from '@themost/angular';
import {TextUtils} from '@themost/client';
import { LinkProfile, NgxProfilesService } from '@universis/ngx-profiles';
import { from, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable()
export class ProfileService {
    constructor(private context: AngularDataContext, private _profiles: NgxProfilesService) {

    }
    
    public student$: Observable<any> = from(this.getStudent()).pipe(shareReplay());

    public studentProfiles$: Observable<LinkProfile[]> = from(this._profiles.supported().then((supported) => {
        if (!supported) {
            return [];
        }
        return this._profiles.getStudentProfiles();
    })).pipe(shareReplay());

    getStudent(): any {
        const sessionStudent = sessionStorage.getItem('student');
        if (sessionStudent != null) {
            return new Promise((resolve, reject) => {
                try {
                    // deserialize student data
                    const res = JSON.parse(sessionStudent, function (key, value) {
                        // parse dates
                        if (TextUtils.isDate(value)) {
                            return new Date(value);
                        }
                        // otherwise return value
                        return value;
                    });
                    // set a small delay
                    setTimeout(() => {
                        // and return result
                        return resolve(res);
                    }, 500);
                } catch (err) {
                    return reject(err);
                }
            });
        }
        return this.context.model('students/me')
            .asQueryable()
            .expand('user', 'department', 'studyProgram', 'studyProgramSpecialty', 'inscriptionMode', 'person($expand=gender)')
            .getItem().then(student => {
                if (typeof student === 'undefined') {
                    return Promise.reject('Student data cannot be found');
                }
                return this.context.model('LocalDepartments')
                    .asQueryable()
                    .where('id').equal(student.department.id)
                    .expand('organization($expand=instituteConfiguration,registrationPeriods)')
                    .getItem().then(department => {
                        if (typeof department === 'undefined') {
                            return Promise.reject('Student department cannot be found');
                        }
                        student.department = department;
                        sessionStorage.setItem('student', JSON.stringify(student));
                        return Promise.resolve(student);
                    });
            });
    }

}
